import i18n from "i18next";
import type { FC } from "react";

import type { FormFieldFactoryProps, FormFieldWrapperProps } from "../../types/types";
import { FormComponent, ValidationType } from "../../types/types";
import { FormFieldInputStyle, FormFieldLabelStyle, HorizontalFormFieldStyle } from "../styles/FormFieldsStyle";
import { withLabelColon } from "../withLabelColon";

interface HorizontalFormFieldWrapperProps {
    field?: FormFieldFactoryProps;
    formComponent: React.JSX.Element;
}

export const HorizontalFormFieldWrapper: FC<HorizontalFormFieldWrapperProps> = ({ field, formComponent }: FormFieldWrapperProps) => {
    const shouldHideFormField = field?.component === "HiddenCheckbox" || field?.component === "HiddenValue"; // hiddenLabel applies styling rules: "display: none;"
    const shouldHideLabel = field?.component === "FileContents" || shouldHideFormField;

    const isDynamicProperties = field?.component === FormComponent.DYNAMIC_PROPERTIES;
    const isDynamicPropertiesRequired =
        field?.attributes?.validationRules?.some((rule) => rule.name === ValidationType.VALIDATION_REQUIRED) ?? false;
    const labelClassName = isDynamicProperties
        ? `aevi-form-field-label-no-derived-required${isDynamicPropertiesRequired ? " aevi-form-field-label-required" : ""}`
        : undefined;

    // Rendered in a wider Col (20/24 instead of 14/24, see FormFieldRender) to reclaim the unused
    // read-only comparison column, so the label/input split must be recomputed too (see wideInput).
    const isNoWrapTextArea = field?.component === FormComponent.TEXT_AREA && !!field?.attributes?.noWrap;

    return (
        (field?.translationKeys && (
            <HorizontalFormFieldStyle hiddenLabel={shouldHideFormField} wideInput={isNoWrapTextArea}>
                <FormFieldLabelStyle className={labelClassName}>
                    {!shouldHideLabel ? withLabelColon(i18n.t(field.translationKeys.label)) : ""}
                </FormFieldLabelStyle>
                <FormFieldInputStyle>{formComponent}</FormFieldInputStyle>
            </HorizontalFormFieldStyle>
        )) || (
            <HorizontalFormFieldStyle hiddenLabel={shouldHideFormField} wideInput={isNoWrapTextArea}>
                <FormFieldInputStyle>{formComponent}</FormFieldInputStyle>
            </HorizontalFormFieldStyle>
        )
    );
};
